import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';

import App from './App.tsx';
import './index.css';
import { initializeMonitoring } from './lib/monitoring';
import { initWebVitals } from './lib/web-vitals';

// Initialize error monitoring
initializeMonitoring();

// Initialize Web Vitals monitoring
initWebVitals();

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
